import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("zp_lang") || "pl");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("zp_lang", l);
  }, []);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      if (node == null) break;
      node = node[p];
    }
    if (node == null) {
      // fallback to other language
      let alt = translations[lang === "pl" ? "en" : "pl"];
      for (const p of parts) { if (alt == null) break; alt = alt[p]; }
      return alt != null ? alt : path;
    }
    return node;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useT = () => useContext(LanguageContext);
